<template>
<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <OsSWList />
    </div>
  </PageRowWrapper>
</div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActionButton from '@/components/button/ActionButton'
import OsSWList from '@/components/os-sw/OsSWList'

export default {
  name: 'OsSW',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    OsSWList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addossw' })
    }
  }
}
</script>
